import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function InsuranceLayout() {
  const productType = useSelector((state) => state.token.productType);

  if (productType !== "Other Insurance") {
    // not the correct product type, redirect to products
    return <Navigate to={`/products`} />;
  }

  return <Outlet />;
}
